import { Alert } from '@ordo/ui/alert'
import { AlertOctagon } from 'lucide-react'

interface MissedDeadlineSummaryBannerProps {
  count: number
}

export function MissedDeadlineSummaryBanner({ count }: MissedDeadlineSummaryBannerProps) {
  const subject = count === 1 ? 'school has' : 'schools have'
  return (
    <Alert variant="error" className="mx-4 flex items-start gap-3 lg:mx-0">
      <AlertOctagon className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={2} />
      <div className="flex flex-col gap-1">
        <div className="font-medium">
          {count} {subject} not submitted orders for this week
        </div>
        <div className="text-red-900/80">
          This may indicate a system issue — a subscription batch may have failed to run. Contact ops to investigate.
        </div>
      </div>
    </Alert>
  )
}
